export default __webpack_public_path__ + "static/media/app_store.3df42f5c.svg";